import updateProfile from 'services/api/profile/updateProfile';
import constants from 'services/api/profile/constants';

const { EmailSubscriptionTypes, SubscriptionStatus, PromotionalEmailsPrefsFrequency } = constants;

function setCommunicationPreferences(prefs) {
    const subscriptionPreferredCountry = prefs?.subscriptionPreferredCountry || '';
    const subscriptionPreferredLanguage = prefs?.subscriptionPreferredLanguage || '';
    const subscriptionPreferredZipCode = prefs?.subscriptionPreferredZipCode || '';

    const subscriptionsPayload = {
        subscriptionPreferredCountry,
        subscriptionPreferredLanguage,
        subscriptions: []
    };

    // For each subscription the user has, a subscription object needs to be added.
    if (prefs?.notificationsAndReminders?.subscribed) {
        subscriptionsPayload.subscriptions.push({
            subscriptionRegion: subscriptionPreferredCountry,
            subscriptionFrequency: PromotionalEmailsPrefsFrequency.DAILY,
            subscriptionZip: subscriptionPreferredZipCode,
            subscriptionType: EmailSubscriptionTypes.TRIGGERED,
            countryLocation: subscriptionPreferredCountry,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionLanguage: subscriptionPreferredLanguage
        });
    }

    if (prefs?.promotionalEmail?.subscribed) {
        subscriptionsPayload.subscriptions.push({
            subscriptionRegion: subscriptionPreferredCountry,
            subscriptionFrequency: prefs?.promotionalEmail?.frequency || PromotionalEmailsPrefsFrequency.DAILY,
            subscriptionZip: subscriptionPreferredZipCode,
            subscriptionType: EmailSubscriptionTypes.CONSUMER,
            countryLocation: subscriptionPreferredCountry,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionLanguage: subscriptionPreferredLanguage
        });
    }

    if (prefs?.postalMail?.subscribed) {
        subscriptionsPayload.subscriptions.push({
            subscriptionRegion: subscriptionPreferredCountry,
            subscriptionFrequency: prefs?.postalMail?.frequency || PromotionalEmailsPrefsFrequency.ANNUAL,
            subscriptionZip: subscriptionPreferredZipCode,
            subscriptionType: EmailSubscriptionTypes.MAIL,
            countryLocation: subscriptionPreferredCountry,
            subscriptionStatus: SubscriptionStatus.SUBSCRIBED,
            subscriptionLanguage: subscriptionPreferredLanguage
        });
    }

    return updateProfile(subscriptionsPayload);
}

export default {
    setCommunicationPreferences
};
